<template>
    <div class="container-fluid mb-5 ps-5">
        <div class="row">
            <div class="col">
                <img @click="$emit('go-back-event')" src="../../assets/back-button.svg" class="img-fluid cursor-pointer" width="32" alt="">
            </div>
        </div>
    </div>
    <div class="container">
        <div class="row">
            <div class="col text-center">
                <h1 class="thin-text mb-5 fs-3">Cosa voglio realizzare?</h1>
            </div>
        </div>
    </div>
    <div class="custom-container">
        <form @submit.prevent="validateForm" id="formId" method="post" novalidate="true">
            <div class="row mb-5">
                <div class="col-lg-2"></div>
                <div class="col-lg-3">
                    
                    <label class="custom-checkbox">
                        <input v-model="eventTypes" type="checkbox" name="eventType1" id="SecondaCasa" value="Seconda casa" required @change="sendEventList()">
                        <img class="mb-3" src="../../assets/realizzare-screen/2/seconda-casa.png" alt="">
                        <span class="thin-text">Seconda casa</span>
                    </label>
                </div>
                <div class="col-lg-3">
                    <label class="custom-checkbox">
                        <input  v-model="eventTypes"  type="checkbox" name="eventType2" id="Auto" value="Auto" required @change="sendEventList()">
                        <img class="mb-3" src="../../assets/realizzare-screen/2/auto.png" alt="">
                        <span class="thin-text">Auto</span>
                    </label>
                </div>
                <div class="col-lg-3">
                    <label class="custom-checkbox">
                        <input v-model="eventTypes" type="checkbox" name="eventType3" id="Barca" value="Barca" required @change="sendEventList()">
                        <img class="mb-3" src="../../assets/realizzare-screen/2/barca.png" alt="">
                        <span class="thin-text">Barca</span>
                    </label>
                </div>
            </div>
            <div class="row mb-5">
                <div class="col-lg-3"></div>
                
                <div class="col-lg-3">
                    <label class="custom-checkbox">
                        <input v-model="eventTypes" type="checkbox" name="eventType4" id="Credito" value="Credito" required @change="sendEventList()">
                        <img class="mb-3" src="../../assets/realizzare-screen/2/reddito.png" alt="">
                        <span class="thin-text">Integrazione al proprio credito</span>
                    </label>
                </div>
                <div class="col-lg-3">
                    <label class="custom-checkbox">
                        <input v-model="eventTypes" type="checkbox" name="eventType5" id="Altro" value="Altro" required @change="sendEventList()">
                        <img class="mb-3" src="../../assets/realizzare-screen/2/altro.png" alt="">
                        <span class="thin-text">Altro</span>
                    </label>
                </div>
                <div class="col-lg-3 d-flex align-items-center"  v-if="this.formData.eventTypes.includes('Altro')">
                    <input v-model="formData.eventOther" type="text" class="form-control" id="other" placeholder="Scrivi...">
                </div>
            </div>
            
            <div class="text-center mb-3">
                <input type="submit" value="Procedi">
            </div>
        </form>

    </div>
    <div class="container" v-if="this.errors.length > 0">
        <div class="row">
            <ul class="list-unstyled col-lg-6 offset-3">
                <li class="alert alert-danger p-2 mb-1" role="alert" :key="key" v-for="(error, key) in this.errors">
                    {{error}}
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'RealizeSelfScreen',
        emits: ['go-to-event', 'go-back-event', 'save-form-data-event'],
        props: {
            formData: {
                type: Object,
                default(rawProps) {
                    return {
                        eventTypes: [],
                        eventAge: null,
                    }
                }
            }
            
        },
        data() {
            return {
                errors: [],
                eventTypes: this.formData.eventTypes
            }
        },
        methods: {
            validateForm() {
                // Check for errors
                this.errors = [];
                if (this.formData.eventTypes.length == 0 ) {
                    this.errors.push("Cosa voglio realizzare mancante");
                }
                if (this.formData.eventTypes.includes("Altro")) {
                    if (!this.formData.eventOther || this.formData.eventOther == "") {
                        this.errors.push("Altro mancante");
                    }
                }
                // No errors found
                if (this.errors.length == 0) {
                    this.$emit('save-form-data-event', this.formData);
                    this.$emit('go-to-event', 'ContractFiguresSelfScreenId');
                    return true;
                }
            },
            sendEventList(){
                this.formData.eventTypes = this.eventTypes;
            },
        }
    }
</script>